// @ts-strict-ignore
import type * as React from 'react';
import { styled, Box } from '@mui/material';
import type { SxProps } from '@mui/material';
import type { NamedColors } from '../../theme';

export type TextSizes = 'xs' | 'sm' | 'default' | 'lg' | 'xl';

type TextPropsForStyle = {
    color?: NamedColors;
    fontWeight?: number | string;
    textTransform?: React.CSSProperties['textTransform'];
    noWordBreak?: boolean;
};
type TextProps = TextPropsForStyle & {
    size?: TextSizes;
    className?: string;
    children: React.ReactNode;
    sx?: SxProps;
    style?: object;
};

export const Text = styled(Box, {
    shouldForwardProp(propName) {
        return ![
            'size',
            'color',
            'fontWeight',
            'textTransform',
            'noWordBreak',
        ].includes(propName.toString());
    },
})<TextProps>(
    ({ theme, color, size, noWordBreak, fontWeight, textTransform }) => ({
        letterSpacing: 'normal',
        fontWeight,
        textTransform,
        color: theme.bino.color[color] ?? color,
        wordWrap: 'break-word',
        whiteSpace: noWordBreak ? 'nowrap' : undefined,
        display: noWordBreak ? 'inline-block' : 'inline',
        overflow: noWordBreak ? 'hidden' : undefined,
        textOverflow: noWordBreak ? 'ellipsis' : undefined,
        fontSize: {
            xs: 12,
            sm: 14,
            default: 18,
            lg: 20,
            xl: 24,
        }[size],
        lineHeight: {
            xs: '16px',
            sm: '22px',
            default: '28px',
            lg: '28px',
            xl: '32px',
        }[size],
        [`${theme.breakpoints.down('sm')}`]: {
            fontSize: {
                xs: 10,
                sm: 12,
                default: 16,
                lg: 18,
                xl: 22,
            }[size],
            lineHeight: {
                xs: '14px',
                sm: '16px',
                default: '20px',
                lg: '22px',
                xl: '26px',
            }[size],
        },
    }),
);

export default Text;
